/**
 * @module Utilities/Strings
 * @desc Strings helper funtions
 */

/**
 * Converts string to toUpperCase and Capitalize first letter
 */
export function upperCaseToLowerCase(str: string) {
  return str.charAt(0).toUpperCase() + str.substring(1).toLowerCase();
}
